(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-bac-track]');
    var prevBtn = root.querySelector('[data-bac-prev]');
    var nextBtn = root.querySelector('[data-bac-next]');
    var dots = root.querySelectorAll('[data-bac-dot]');
    var slides = root.querySelectorAll('[data-bac-slide]');

    if (!track) return;

    function slideWidth() {
      var slide = track.querySelector('.bac-slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap || 20);
      return slide.getBoundingClientRect().width + gap;
    }

    function currentIndex() {
      var width = slideWidth();
      if (!width) return 0;
      return Math.round(track.scrollLeft / width);
    }

    function updateUI() {
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll - 4;

      var index = currentIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goToIndex(index) {
      var width = slideWidth();
      var maxIndex = slides.length - 1;
      var clamped = Math.max(0, Math.min(index, maxIndex));
      track.scrollTo({ left: clamped * width, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToIndex(currentIndex() - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToIndex(currentIndex() + 1);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goToIndex(i);
      });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateUI);
    });

    updateUI();
    window.addEventListener('resize', updateUI);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('[data-bac-carousel]');
    carousels.forEach(function (root) {
      initCarousel(root.closest('.bac'));
    });
  });
})();